// extracted by mini-css-extract-plugin
export default {"searchText":"course-list_component_searchText__W6r0h","textFieldset":"course-list_component_textFieldset__N8-EI"};